<template lang="pug">
  main.main.main_tracking
    header.main__header
      article.product.product_tracking
        .product__wrap-img
          img.product__img(:src="product.Picture", alt='')
        .product__container
          h1.product__title {{ product.NAME }}
          h2.product__barcode {{ product.IMEI }}
          .product__days
            .product__date-buy
              | {{ $t('tracking.guarantee_date') }}
              time {{ tracking.guarantee_date }}
            template(v-if="tracking.is_guarantee")
              .product__guaranty.product__guaranty_ok
                | {{ $t('tracking.guaranty') }}
            template(v-else)
              .product__guaranty.product__guaranty_no {{ $t('tracking.no-guaranty') }}
          .product__select(v-if="tracking.can_close && tracking.can_edit_delivery_address")
            .drop
              .drop__overlay(v-if="drop" @click="drop = !drop")
              .drop__btn(@click="drop = !drop")
                span {{ $t('tracking.drop.title') }}
              .drop__down(v-if="drop")
                ul.drop__list
                  router-link.drop__item(v-if="tracking.can_edit_delivery_address"
                    tag='li'
                    :to="$t('tracking.drop.delivery.link')"
                  ) {{ $t('tracking.drop.delivery.text') }}
                  .drop__item(v-if="tracking.can_close"
                    tag='li'
                    @click="requestCancel"
                  ) {{ $t('tracking.drop.close.text') }}
    StyledContent
      StyledRow(
        :full="!tracking.conclusion"
        marginBottom="32px"
      )
        template(v-if="!tracking.conclusion")
          ul.progress
            li.progress__item(v-for="(progress, index) in tracking.status"
                :key='index'
                :class="{'progress__item_active': progress.active}"
              )
              .progress__text {{ progress.title }}
        template(v-else)
          p.main__text Заключение инженера:
          .main__description
            p.main__text.main__text_bold {{ tracking.conclusion.title }}
          table.table.table_tracking
            caption.table__caption Стоимость ремонта:
            tbody.table__body
              tr.table__row(v-for="(row, index) in tracking.conclusion.price_list"
                :key="index")
                td.table__key  {{ row.title }}
                td.table__value  {{ row.price }}
            tfoot.table__foot
              tr.table__row
                td.table__key
                  span Итого
                td.table__value
                  span {{ tracking.conclusion.total_price }}
          .main__buttons
            .button.main__button(@click="acceptRequest") {{ $t('tracking.product.NoGuaranty.buttons.ok') }}
            .button.main__button.button_transparent(@click="requestCancel") {{ $t('tracking.product.NoGuaranty.buttons.cancel') }}
      StyledRow(
        v-if='tracking.hasTtn'
        marginBottom="32px"
      )
        form.form.form__ttn.main__form(@submit.prevent="submitForm")
          TextInputGlossary(
            label="ТТН отправленного устройства",
            :error="$v.ttn.$error"
            errorText="Неверно введен номер ТТН"
            :value="$v.ttn.$model"
            v-on:change-input="(e) => {setTTNText(e)}"
            class="form__input"
            :disabled="!tracking.can_edit_ttn"
          )
            p Номер товарно-транспортной накладной, по которой вы отправили устройство к нам на сервис.
            figure
              img(
              src="../assets/img/ttn.png"
              )
          footer.form__footer(v-if="tracking.can_edit_ttn")
            input.button.form__submit(type='submit', :value="btnText", :disabled='$v.ttn.$invalid')
</template>

<script>
import { mapGetters } from 'vuex'
import { TextInputGlossary } from './TextInput'
// import { requiredIf } from 'vuelidate/lib/validators'

import { api } from '@/store/http-common'
import {
  StyledContent,
  StyledRow
} from './Layouts/StyledLayouts'
import {
  StyledAddress
} from './Address/StyledAddress'

const objectToFormData = require('object-to-formdata')
const ttnValidator = (value) => value.indexOf('100') === 0 ? value.length === 11 : value.length === 14

export default {
  name: 'Tracking',
  props: ['tn'],
  data () {
    return {
      loading: false,
      drop: false,
      ttn: '',
      btnText: 'Отправить ТТН'
    }
  },
  validations: {
    ttn: {
      ttnValidator
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      await this.$store.dispatch('getTrackingData', this.tn)
      await this.$store.dispatch('getProduct', this.seriesNumber)
      if (this.tracking.ttn) {
        this.setTTNText(this.tracking.ttn)
        this.btnText = 'Изменить'
      }
    },
    acceptRequest () {
      this.$store.dispatch('repairRequestAccept')
    },
    requestCancel () {
      this.$store.dispatch('repairRequestCancel')
    },
    setTTNText (value) {
      this.ttn = value
      this.$v.ttn.$touch()
    },
    submitForm () {
      let data = objectToFormData({
        ttn: this.ttn,
        code: this.tn
      })

      api
        .post('ajax.php?action=sg:service.api.repairrequest.setTtn', data)
        .then(response => {
          if (response.data.status === 'success') {
            if (response.data.data) {
              this.btnText = 'Отправлено'
            }
          }
        }, error => {
          console.log(error)
        })
    },
    parsePhone (string) {
      return string.replace(/[^+0-9]/g, '')
    }
  },
  computed: {
    ...mapGetters({
      product: 'getProduct',
      tracking: 'getRequestAnswer',
      seriesNumber: 'getSeriesNumber'
    })
  },
  components: {
    TextInputGlossary,
    StyledContent,
    StyledRow,
    StyledAddress
  }
}
</script>

<style scoped lang="scss">
  .form.form__ttn {
    max-width: 470px;

    @media screen and (min-width: 1200px) {
      margin-left: 120px;
    }

    .form__input {
      margin-bottom: 24px;
    }

    .form__footer {
      display: flex;
      justify-content: flex-end;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Tracking.vue